import logo from './logo.svg';
import './App.css';
import {useState} from "react"
import Posts from './components/Posts';

function App() {
//   const [text,setText]=useState("");
//   const [todo,setTodo]=useState([])
//   const handAdd=()=>{
//     setTodo([...todo,
//     {
//       id:Date.now().toString(),
//       title:text,
//       status:false
//     }])
//   }
  return (
    <div className="App">
            <Posts/>

      {/* <header className="App-header">
        <div>
          <input value={text} placeholder="write here" onChange={e=>setText(e.target.value)} />
          <button onClick={handAdd} >Add</button>
        </div>
        <ul>
          {
            todo.map(item=><li key={item.id}>{item.title} </li>)
          }
        </ul>
      </header> */}
    </div>
  );
    }

export default App;
